import {EmailValidator} from './email-validator';

export class LreRecipient {
  public title: string;
  public firstName: string;
  public lastName: string;
  public company: string;
  public address: string [];
  public locale: string;
  public mailAddress: string;
  public phoneNumber: string;
  public authenticationType: string;
  public signerQuality: string;
  public consentObtained: boolean;

  constructor() {
    this.title = '';
    this.firstName = '';
    this.lastName = '';
    this.company = '';
    this.address = [];
    this.locale = 'fr';
    this.mailAddress = '';
    this.phoneNumber = '';
    this.authenticationType = 'mailOTP';
    this.signerQuality = 'INDIVIDUAL';
    this.consentObtained = true;
  }

  public stringify(): string {
    const addresses = this.address;
    this.address = this.address[0].split('\n');
    const json = JSON.stringify(this);
    this.address = addresses;
    return json;
  }
  public isValidAddress(): boolean {
    if (this.address.length === 1) {
      return (this.address[0].split('\n').length >= 2);
    }
    else {
      return this.address.length >= 2;
    }
  }
  public isValid(): boolean {
    if (this.authenticationType === 'smsOTP' && this.phoneNumber === '') {
      return false;
    }
    return (
        (this.title !== '' && this.firstName !== '' && this.lastName !== '')
        || this.company !== ''
      )
      && this.isValidAddress()
      && this.mailAddress !== '' && EmailValidator.emailIsValid(this.mailAddress);
  }
}
